module.exports = __webpack_public_path__ + "img/shield-check.fcf4dab7.svg";